import { render, staticRenderFns } from "./PassengersSelection.vue?vue&type=template&id=1069f258&scoped=true"
import script from "./PassengersSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PassengersSelection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1069f258",
  null
  
)

export default component.exports